// extracted by mini-css-extract-plugin
export default {"iconOutline":"IconWithLabel_iconOutline__AphYo","text":"IconWithLabel_text__d5VK4"};